// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetAppLogsRequestModel from '../../model/get-app-logs-request-model';
import AppLogPagingResultModel from '../../model/app-log-paging-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getAppLogs(request: GetAppLogsRequestModel, config?: RequestConfig) {
    const requestDTO = GetAppLogsRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-app-logs'] ?? 'core/admin/AppLogs';
    const response = await service.get<any>(endpointPath, {
      query: {
        dateFrom: requestDTO.dateFrom,
        dateTo: requestDTO.dateTo,
        levels: requestDTO.levels,
        correlationId: requestDTO.correlationId,
        appTransactionId: requestDTO.appTransactionId,
        appUserId: requestDTO.appUserId,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(AppLogPagingResultModel.toModel(dto));
  },
});
